import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import "./LegalPage.css";

function About() {
  const { locale } = useI18n();

  if (locale === "pl") {
    return (
      <div className="legal-page">
        <div className="legal-card">
          <Link to="/" className="legal-back-link">
            ← Powrót do TajneMysli
          </Link>

          <h1>O SPARKY</h1>

          <section>
            <h2>Informacje o firmie</h2>
            <p>
              SPARKY SIMPLE JOINT-STOCK COMPANY
              <br />
              ul. Aleje Jerozolimskie 109
              <br />
              02-011 Warszawa
              <br />
              Polska
            </p>
          </section>

          <section>
            <h2>Dane rejestrowe</h2>
            <p>
              KRS: 0001259364
              <br />
              NIP: 5223381007
              <br />
              REGON: 5454494130000
              <br />
              Rejestr: Krajowy Rejestr Przedsiębiorców
            </p>
          </section>

          <section>
            <h2>Kontakt</h2>
            <p>
              E-mail:{" "}
              <a href="mailto:sawtraffic@protonmail.com">
                sawtraffic@protonmail.com
              </a>
            </p>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-card">
        <Link to="/" className="legal-back-link">
          Back to TajneMysli
        </Link>

        <h1>About SPARKY</h1>

        <section>
          <h2>Company Information</h2>
          <p>
            SPARKY SIMPLE JOINT-STOCK COMPANY
            <br />
            ul. Aleje Jerozolimskie 109
            <br />
            02-011 Warsaw
            <br />
            Poland
          </p>
        </section>

        <section>
          <h2>Registration Details</h2>
          <p>
            KRS: 0001259364
            <br />
            NIP: 5223381007
            <br />
            REGON: 5454494130000
            <br />
            Registered in: National Register of Entrepreneurs
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            E-mail: <a href="mailto:sawtraffic@protonmail.com">sawtraffic@protonmail.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default About;